import React, { FC } from 'react';

/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';
import { connect } from 'react-redux';

import { ForgeModuleIcon } from '@atlassian/bitbucket-forge-ui-utils';

import {
  extensionTitle,
  ForgeRepoCodeOverviewCardExtensionPoint,
  ForgeRepoCodeOverviewCardExtensionPointProps,
} from 'src/components/forge-ui/src';
import { User } from 'src/components/types';
import { useForgeBridge } from 'src/hooks/forge-bridge';
import { ConnectedExpander } from 'src/sections/repository/sections/pull-request/components/connected-expander';
import { getCurrentRepository } from 'src/selectors/repository-selectors';
import { getCurrentUser } from 'src/selectors/user-selectors';
import { BucketState } from 'src/types/state';

export type ForgeRepoCodeOverviewCardsProps = Omit<
  ForgeRepoCodeOverviewCardExtensionPointProps,
  'WrapperComponent' | 'workspace'
> & { currentUser?: User | null };

const FORGE_REPO_CODE_OVERVIEW_CARD_COLLAPSED_LOCALSTORAGE_KEY =
  'forge.repo.code.overview.card.collapsed';

const ExpanderMargin = styled.div`
  &:not(:first-child) {
    margin-top: 12px;
  }
`;

const ForgeRepoCodeOverviewCardsWrapper: ForgeRepoCodeOverviewCardExtensionPointProps['WrapperComponent'] =
  ({ app, children }) => {
    return (
      <ExpanderMargin>
        <ConnectedExpander
          localStorageKey={`${FORGE_REPO_CODE_OVERVIEW_CARD_COLLAPSED_LOCALSTORAGE_KEY}-${app.id}`}
          icon={<ForgeModuleIcon iconUrl={app.properties.icon} />}
          label={extensionTitle(app)}
        >
          {children}
        </ConnectedExpander>
      </ExpanderMargin>
    );
  };

/* eslint @typescript-eslint/ban-types: "warn" */
const ForgeRepoCodeOverviewCards: FC<ForgeRepoCodeOverviewCardsProps> = ({
  currentUser,
  repository,
}) => {
  const forgeBridgeProps = useForgeBridge();

  if (!repository || !repository.workspace) return null;

  return (
    <ForgeRepoCodeOverviewCardExtensionPoint
      bridge={forgeBridgeProps}
      currentUser={currentUser || undefined}
      repository={repository}
      workspace={repository.workspace}
      WrapperComponent={ForgeRepoCodeOverviewCardsWrapper}
    />
  );
};

const mapStateToProps = (state: BucketState) => ({
  repository: getCurrentRepository(state),
  currentUser: getCurrentUser(state),
});

// Default export is needed because this is lazy loaded by LazyForgeRepoCodeOverviewCards
export default connect(mapStateToProps)(ForgeRepoCodeOverviewCards);
